import React, {memo} from 'react';

import {Box, TextField} from '@mui/material';

export const ParagraphTextPreview: React.FC = memo(() => {
  return (
    <Box>
      <TextField
        variant="outlined"
        multiline
        disabled
        fullWidth
        placeholder="Sua resposta"
      />
    </Box>
  );
});
